var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnterpriselogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0329 18.75L30.9671 18.75C31.9872 18.75 32.3878 17.3986 31.539 16.8206L23.1438 11.1038C22.4512 10.6321 21.5488 10.6321 20.8562 11.1038L12.461 16.8206C11.6122 17.3986 12.0128 18.75 13.0329 18.75Z",
    fill: "#868687"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 20.25H18.5V25.25H15.5V20.25Z",
    fill: "#868687"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 20.25H25.5V25.25H28.5V20.25Z",
    fill: "#868687"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 20.25H23.5V25.25H20.5V20.25Z",
    fill: "#868687"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2764 27.3028C30.107 26.964 29.7607 26.75 29.382 26.75L14.618 26.75C14.2393 26.75 13.893 26.964 13.7236 27.3028L12.7236 29.3028C12.3912 29.9677 12.8747 30.75 13.618 30.75H30.382C31.1253 30.75 31.6088 29.9677 31.2764 29.3028L30.2764 27.3028Z",
    fill: "#868687"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterpriselogo);
export default __webpack_public_path__ + "static/media/Enterprise logo.b306c5f0a0ac3c6deb642253ace2163a.svg";
export { ForwardRef as ReactComponent };